<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      :show-save-button="!readonly"
      title="管理学生"
      id-key="DormitoryId"
      :data="data"
      form-label-width="80px"
      @edit-opened="onEditOpened"
      :save-func="api.save"
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      :close-on-saved="false"
      @saved="onEditOpened({},data.TermId)"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期名称" class="is-required" style="margin-bottom:0;">
              <el-select v-model="data.TermId" @change="getStudents">
                <el-option
                  v-for="item in termList"
                  :key="item.TermId"
                  :value="item.TermId"
                  :label="item.TermName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>宿舍学生列表</span>
              <div style="float: right;" v-if="!readonly">
                <el-button type="primary" icon="el-icon-plus" @click="addSt">添加</el-button>
              </div>
            </div>
            <el-table class="tb-c-head" :data="tableData" border>
              <el-table-column label="学生姓名" prop="FullName" />
              <el-table-column label="操作" align="center" fixed="right" width="60px" v-if="!readonly">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="del(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer" v-if="readonly">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <st-dialog ref="stDialog" in-dialog selectable :multiple="true" :show-term="false" @select-multiple="setST" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import stDialog from "@/components/st/student/listDialog";
import termApi from "@/api/ed/term";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    stDialog
  },
  data() {
    return {
      api: require("@/api/lo/dorm").default,
      isMB: this.$store.state.isMB,
      readonly: !this.$permission.canWrite(),
      data: {
        TermId: 0,
        DormitoryId: null,
        DormitoryAddr: "",
        DormitoryFloor: 0,
        DormitoryNumber: "",
        Capacity: 0,
        Students: [],
      },
      tableData: [],
      delList: [],
      termList: [],
    };
  },
  methods: {
    onEditOpened(row,TermId=0) {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      if(!TermId) {
        this.data.TermId = loginInfo.TermId;
      }
      this.loading(true);
      termApi.list().then((res) => {
        this.termList = res.Data;
        this.getStudents();
      });
    },
    getStudents() {
      this.delList = [];
      this.api.info2({ id: this.data.DormitoryId, termId: this.data.TermId }).then(res => {
        this.loading(false);
        this.data.Students = res.Data.Students||[];
        this.data.Students.forEach(e => {
          e.T = 1;
        })
        this.tableData = this.data.Students;
      })
    },
    addSt() {
      this.$refs.stDialog.open().then((that) => {
        that.getData({});
      });
    },
    setST(sts) {
      if(sts.length == 0) return;
      var same = [];
      sts.forEach(e => {
        var obj = this.tableData.find(x => {
          return x.StudentId == e.StudentId;
        })
        if(obj) {
          same.push(e.FullName);
        } else {
          this.tableData.push({
            T: 0,
            StudentDormitoryId: 0,
            TermId: this.data.TermId,
            StudentId: e.StudentId,
            FullName: e.FullName,
            DormitoryId: this.data.DormitoryId,
          });
        }
      })
      if(same.length) {
        this.$message.error("已存在相同的学生：" + same.join("，"));
      }
    },
    del(row,index) {
      if(!(row.T===0)) {
        row.T = 2;
        this.delList.push(row);
      }
      this.tableData.splice(index,1);
    },
    onBeforeSave() {
      var td = this.tableData;
      var dl = this.delList;
      this.data.Students = td.concat(dl);
    },
    onClosed() {
      this.tableData = [];
      this.delList = [];
    },
  },
};
</script>